<iframe style="height:calc(100vh - 70px);width: 100%; border:0px" frameBorder="0" [src]="urlSafe"></iframe>